import jsPDF from "jspdf";
import { COURSE_INFO, STEPS } from "../data/program";

// Palette
const BG = [5, 8, 16];
const PANEL = [18, 26, 47];
const CYAN = [0, 240, 255];
const WHITE = [248, 250, 252];
const SLATE = [148, 163, 184];
const MUTED = [90, 105, 130];

export function generateProgramFlyer() {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 44;
  const CW = W - M * 2;

  const bg = () => {
    doc.setFillColor(...BG);
    doc.rect(0, 0, W, H, "F");
  };
  const footer = (label) => {
    doc.setDrawColor(30, 41, 59);
    doc.setLineWidth(0.5);
    doc.line(M, H - 34, W - M, H - 34);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(...MUTED);
    doc.text("WALL BOARD ACADEMY  ·  www.wallboardacademy.com", M, H - 22);
    doc.text(label, W - M, H - 22, { align: "right" });
  };

  // ---------- COVER ----------
  bg();
  // cyan side bar
  doc.setFillColor(...CYAN);
  doc.rect(0, 0, 6, H, "F");

  let y = 90;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(...CYAN);
  doc.text("ADVANCED COURSE ON ABDOMINAL WALL RECONSTRUCTION", M, y);

  y += 46;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(40);
  doc.setTextColor(...WHITE);
  doc.text("WALL BOARD", M, y);
  y += 42;
  doc.setTextColor(...CYAN);
  doc.text("ACADEMY", M, y);

  y += 30;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(15);
  doc.setTextColor(...SLATE);
  doc.text("New Techniques & Innovations", M, y);

  // Step summary boxes
  y += 34;
  const boxH = 96;
  STEPS.forEach((s) => {
    doc.setFillColor(...PANEL);
    doc.rect(M, y, CW, boxH, "F");
    doc.setFillColor(...CYAN);
    doc.rect(M, y, 3, boxH, "F");

    doc.setFont("helvetica", "bold");
    doc.setFontSize(26);
    doc.setTextColor(...CYAN);
    doc.text(s.n, M + 18, y + 44);

    doc.setFontSize(9);
    doc.setTextColor(...MUTED);
    doc.text(`STEP ${s.n}`, M + 66, y + 24);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(...WHITE);
    const title = doc.splitTextToSize(s.focus, CW - 90);
    doc.text(title, M + 66, y + 42);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(...CYAN);
    doc.text(s.dates, M + 66, y + boxH - 20);

    y += boxH + 12;
  });

  // Organized by + venue block
  y += 6;
  doc.setDrawColor(30, 41, 59);
  doc.line(M, y, W - M, y);
  y += 20;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...CYAN);
  doc.text("ORGANIZED BY", M, y);
  y += 15;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...WHITE);
  doc.text(doc.splitTextToSize(COURSE_INFO.organized_by, CW), M, y);

  y += 34;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...CYAN);
  doc.text("VENUE", M, y);
  y += 15;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...SLATE);
  doc.text(doc.splitTextToSize(COURSE_INFO.venue, CW), M, y);

  footer("Preliminary Program");

  // ---------- DETAILED PROGRAM ----------
  const bottom = H - 60;
  STEPS.forEach((step) => {
    doc.addPage();
    bg();
    doc.setFillColor(...CYAN);
    doc.rect(0, 0, 6, H, "F");
    let yy = 70;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(30);
    doc.setTextColor(...CYAN);
    doc.text(step.n, M, yy);
    doc.setFontSize(9);
    doc.setTextColor(...MUTED);
    doc.text(`STEP ${step.n}  ·  ${step.dates}`, M + 46, yy - 16);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.setTextColor(...WHITE);
    const ft = doc.splitTextToSize(step.focus, CW - 46);
    doc.text(ft, M + 46, yy + 2);
    yy += Math.max(20, ft.length * 16) + 18;

    doc.setDrawColor(30, 41, 59);
    doc.line(M, yy, W - M, yy);
    yy += 20;

    step.sessions.forEach((s) => {
      const titleLines = doc.splitTextToSize(s.t, CW - 150);
      const rowH = Math.max(16, titleLines.length * 13) + 8;
      if (yy + rowH > bottom) {
        footer(`Step ${step.n} — Program`);
        doc.addPage();
        bg();
        doc.setFillColor(...CYAN);
        doc.rect(0, 0, 6, H, "F");
        yy = 70;
      }
      // bullet
      doc.setFillColor(...CYAN);
      doc.rect(M, yy - 7, 4, 4, "F");
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10.5);
      doc.setTextColor(...WHITE);
      doc.text(titleLines, M + 14, yy);
      // speaker
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8.5);
      doc.setTextColor(...CYAN);
      doc.text(s.s, W - M, yy, { align: "right" });
      yy += rowH;
    });

    footer(`Step ${step.n} — Program`);
  });

  // ---------- REGISTRATION PAGE ----------
  doc.addPage();
  bg();
  doc.setFillColor(...CYAN);
  doc.rect(0, 0, 6, H, "F");
  let ry = 74;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(24);
  doc.setTextColor(...WHITE);
  doc.text("Registration", M, ry);
  ry += 30;

  COURSE_INFO.fees.forEach((f) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(...SLATE);
    doc.text(f.label, M, ry);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(...CYAN);
    doc.text(f.price, W - M, ry, { align: "right" });
    ry += 10;
    doc.setDrawColor(30, 41, 59);
    doc.line(M, ry, W - M, ry);
    ry += 18;
  });

  ry += 6;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...CYAN);
  doc.text("THE FEE INCLUDES", M, ry);
  ry += 16;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...SLATE);
  COURSE_INFO.includes.forEach((inc) => {
    doc.setFillColor(...CYAN);
    doc.rect(M, ry - 6, 3, 3, "F");
    doc.text(doc.splitTextToSize(inc, CW - 16), M + 12, ry);
    ry += 20;
  });

  ry += 12;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(...CYAN);
  doc.text("ORGANIZING SECRETARIAT", M, ry);
  ry += 16;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(...SLATE);
  doc.text(doc.splitTextToSize(COURSE_INFO.secretariat, CW), M, ry);

  footer("Registration & Info");

  doc.save("Wall-Board-Academy-Program.pdf");
}
